import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/index';
import { authMiddleware } from '../hoc/authMiddleware';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['portfolio/setPortfolioImageFile'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.file', 'meta.file', 'meta.arg.image', 'meta.arg.logo'],
        // Ignore these paths in the state
        ignoredPaths: ['portfolio.portfolioImageFile'],
      },
    }).concat(authMiddleware),
});


export type AppDispatch = typeof store.dispatch;
export default store;